import { HostsV2Form } from "./HostsV2Form";

export default HostsV2Form;
